import module from 'recursoshumanos/module.js'
import template from './template.html'

const catalogoTipoMovimiento= {
  2: 'Baja',
  3: 'Modificación',
  8: 'Alta',
}

export class RecursoshumanosCargarmovimientosRegistrosComponent {
  data
  onChange
  resultados = []
  filtro = ''
  catalogo = {
    tipoMovimiento: catalogoTipoMovimiento,
  }

  $onChanges (changes) {
    if (changes.data) {
      this.data = Array.isArray(this.data) ? this.data : []
      this.noAprobar = this.data.some((item) => item.resultados.length === 1 && !item.seleccionado)
      this.filtrar()
    }
  }

  filtrar () {
    let filtro = (this.filtro && this.filtro.toUpperCase()) || ''
    this.resultados = (this.data.length && this.data.filter((item) => item.registro.nombre.toUpperCase().indexOf(filtro) >= 0)) || []
  }

  aprobarTodos () {
    this.data.forEach(item => {
      if (item.resultados.length === 1) {
        item.seleccionado = item.resultados[0]
      }
    })
    this.aprobarTodosValidos = false
    this.noAprobar = this.data.some((item) => item.resultados.length === 1 && !item.seleccionado)
    this.filtrar()
    this.notificarCambio()
  }

  notificarCambio () {
    this.onChange({$event: {detail: this.data}})
  }
}

module.component('recursoshumanosCargarmovimientosRegistros', {
  controller: RecursoshumanosCargarmovimientosRegistrosComponent,
  template,
  bindings: {
    data: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/cargarmovimientos/registros/component.js